import Axios from "axios";
import {config} from "@/config";

Axios.defaults.baseURL = config.apiUrl;
Axios.defaults.headers.common['Content-Type'] = 'application/json';

export default {
    namespaced: true,
    state: {
        data: [
        ],
    },
    getters: {
        DATA: state => {
            return state.data;
        },

    },
    mutations: {
        DATA: (state, payload) => {
            return state.data = payload;
        },
    },
    actions: {
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay = true;

            await payload.th.$store.dispatch('SEND_GET', {
                url: '/order/' + payload.th.orderId,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('DATA', responseData.data.orderData);
                    payload.th.isReady = true
                    payload.th.initValue()
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            let formData = new FormData()
            for (let key in state.data) {
                if (key !== 'newPhotos') {
                    formData.append(key, state.data[key])
                }
            }
            for (let key in state.data.newPhotos) {
                formData.append('newPhoto_'+ key, state.data.newPhotos[key])
            }

            console.log(formData)

            payload.th.showOverlay ++
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/order/' + payload.th.orderId,
                parameter: formData,
                config: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    if (responseData.status === "success") {
                        payload.th.GET_DATA({th: payload.th})
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                }
            });
        },
    }
}